<app-header></app-header>

<!-- <div class="container">
    <table class="table table-light">
        <thead class="thead-light">
            <tr>
                <th>رقم التسلسل</th>
                <th>اسم الدورة التدربية</th>
                <th>الوصـــف</th>
                <th>الصـــورة</th>
                <th>القســـم</th>
                <th>العمليــات</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let course of courses;let i= index">
                <td>{{course._id}}</td>
                <td>{{course.tittle}}</td>
                <td>{{course.description}}</td>
                <td><img src="{{course.image}}" width="200px" height="auto"/></td>
                <td>{{course.categoryID}}</td>
                <td>
                    <a class="btn btn-secondary " (click)="delete(course._id)" >الحـــذف</a>
                    <a class="btn btn-dark"  routerLink="/EditCourse/{{course._id}}">التعديــــل</a>
                </td>
            </tr>
        </tbody>
    </table>
</div> -->

<div class="container-xxl">
    <section class="banner d-flex justify-content-center align-items-center text-center">
        <div class="content" data-aos="zoom-in" data-aos-duration="2000">
          <div class="title">
            <span>الدورات التدريبية</span>
          </div>
        
          <div class="links">
            <a class="text-decoration-none" routerLink="/home"> الرئيسية </a>
            <span>/ الدورات التدريبية </span>
          </div>
        </div>
      </section>

      <div class="search mt-5">
        <div class="container">
          <div class="row d-flex justify-content-between group">
            <form data-aos="fade-left" data-aos-duration="2000">
              <input  type="text" class="form-control" placeholder="ابحث عن اسم الدورة التدربية " #myInput style="width:400px;">
              <br>
              <button class="search-btn btn btn-warning" (click)="searchByCouresTitle(myInput.value)">ابحـــث</button>
            </form>

            <div class="category-search row d-flex justify-content-center align-items-center" data-aos="fade-right" data-aos-duration="2000">
              <div>
                <span> ابحث باسم القسم : &nbsp; &nbsp;</span>
                <select [(ngModel)]="neededCategory" (change)="changeShowAll()">
                  <option *ngFor="let r of categoriesTitle" value="{{ r._id }}">
                    {{ r.Title }}
                  </option>
                </select>
              </div>
            </div>

          </div>
        </div>
      </div>
    
    <section class="courses mt-5 mb-5">
        <div class="container">            
           <div class="group" *ngFor="let course of renderCourses;let i= index">

            <a class="course row mt-5" routerLink="/getCourseById/{{course._id}}" *ngIf="course.categoryID.includes(neededCategory) || showAll" data-aos="flip-down" data-aos-duration="2000">
                <div class="course-image col-md-3">
                    <!-- {{course.image}} -->
                    <img class="img-fluid" src="https://khairokom-uploadfiles.azurewebsites.net/files/{{course.image}}">
                </div>
    
                <div class="course-content col-md-9 d-flex align-items-center mt-4">
                    <div class="content">
                        <h2 class="title">{{course.tittle}}</h2>                    
                        <p class="desc">{{course.description}}</p> 
                    </div>               
                </div>                        
            </a>  

           </div>      
        </div>
    </section>
</div>

<app-footer></app-footer>
